export default __webpack_public_path__ + "static/media/jsonFile.cc30f763.svg";